import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

// Translator.
import { TranslateService, TranslatePipe, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-mfa-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    TranslatePipe
  ],
  templateUrl: './mfa-dialog.component.html',
  styleUrl: './mfa-dialog.component.scss'
})
export class MfaDialogComponent {
  mfaCode: string = '';

  constructor(
    public dialogRef: MatDialogRef<MfaDialogComponent>,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSubmit(): void {
    this.dialogRef.close(this.mfaCode);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
